module.exports = __webpack_public_path__ + "static/canyon-riverview-zoom-b1910b34c16580c260b98b7462873726.jpg";